import { PackageSearch } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

import { DashboardShell } from "@/components/dashboard/dashboard-shell";
import { OrdersClient } from "@/components/dashboard/orders-client";
import { apiGet } from "@/services/api";
import type { OrderWithItems } from "@/types/prisma";

/** `app/dashboard/orders/page.tsx`. */
export function OrdersPage() {
  const [orders, setOrders] = useState<OrderWithItems[] | null>(null);

  useEffect(() => {
    let active = true;
    void apiGet<{ orders: OrderWithItems[] }>("/api/orders").then((data) => {
      if (active) setOrders(data?.orders ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  if (orders === null) {
    return (
      <DashboardShell title="Orders">
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-32 animate-pulse rounded-lg bg-slate-100 dark:bg-white/5" />
          ))}
        </div>
      </DashboardShell>
    );
  }

  if (orders.length === 0) {
    return (
      <DashboardShell title="Orders">
        <div className="rounded-lg border border-slate-200 bg-white p-10 text-center shadow-sm dark:border-white/10 dark:bg-slate-900">
          <PackageSearch className="mx-auto h-12 w-12 text-slate-400" />
          <h2 className="mt-4 text-2xl font-black tracking-normal">No orders yet</h2>
          <p className="mt-2 text-slate-600 dark:text-slate-300">
            When you place an order, it will show up here.
          </p>
          <Link
            href="/search"
            className="mt-5 inline-flex h-11 items-center rounded-md bg-amazon-gold px-5 text-sm font-bold text-slate-950"
          >
            Start shopping
          </Link>
        </div>
      </DashboardShell>
    );
  }

  return (
    <DashboardShell title="Orders">
      <OrdersClient orders={orders} />
    </DashboardShell>
  );
}
